<template>
  <Wrapper>
    <div class="container-fluid pb-0">
      <div class="video-block-right-list section-padding">
        <div class="row mb-4">
          <div class="col-md-8">
            <!-- <VideoPlayer /> -->
            <div class="video">
              <div class="embed">
                <VideoPlyrPlayer
                  :video="post"
                  :options="options"
                />
              </div>
            </div>
          </div>
          <div
            v-if="options.video.show.page.playlist"
            class="col-md-4"
          >
            <!-- <VideoPlaylist /> -->
            <VideoPlyrPlaylist
              :video="post"
              :options="options"
            />
          </div>
        </div>
      </div>
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-8">
            <div class="single-video-left">
              <VideoDescription
                :video="post"
                :options="options"
              />
              <VideoComments
                :video="post"
                :options="options"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-video-right">
              <div class="row">
                <div class="col-md-12">
                  <AdSmall v-if="options.video.show.page.ads" />
                </div>
                <SuggestedVideos
                  v-if="options.video.show.page.suggested"
                  :video="post"
                  :options="options"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import adminPostLoader from '@/mixins/fetcher/loaders/admin/post-loader';
import postLoader from '@/mixins/fetcher/loaders/post-loader';

import { sync } from 'vuex-pathify';

export default {
  components: {
    VideoDescription: () => import('@/components/video/VideoDescription'),
    VideoComments: () => import('@/components/video/VideoComments'),
    SuggestedVideos: () => import('@/components/video/SuggestedVideos'),
    //  VideoPlayer: () => import('@/components/video/VideoPlayer'),
    VideoPlyrPlayer: () => import('@/components/video/VideoPlyrPlayer'),
    //  VideoPlaylist: () => import('@/components/video/VideoPlaylist'),
    VideoPlyrPlaylist: () => import('@/components/video/VideoPlyrPlaylist'),
    AdSmall: () => import('@/components/ads/AdSmall'),
  },

  mixins: [
    adminPostLoader, //
    postLoader, //
  ],

  computed: {
    ...sync([
      'site.options', //
    ]),
  },

  mounted() {
    // console.log('options', this.options);
  },

};
</script>
